module.exports = function(h, row) {
    if (row.products_count == 0) {
        return <i>No products assigned</i>;
    }

    return <i>Assigned to {row.products_count} products</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/tax/products.jsx